import DetailPopup from "./DetailPopup";

export default DetailPopup;
